import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import Dialog from '@zenbusiness/zui/Dialog';
import DialogTitle from '@zenbusiness/zui/DialogTitle';
import IconButton from '@zenbusiness/zui/IconButton';

import ConfirmRestartSubscription from './ConfirmRestartSubscription';
import ContactCS from './ContactCS';
import RequestSuccessful from './RequestSuccessful';
import { baseModalContext } from '../contexts/ChangeRequestContext';
import { useChangeRequestContext, useSetChangeRequest } from '../hooks/useChangeRequestContext';

export default function RestartSubscriptionModalFlow({
  subscription,
  businessEntity,
  serviceDisplayName,
  refetchSubscriptions
}) {
  const { formatMessage } = useIntl();
  const { changeFlow } = useChangeRequestContext();
  const { setChangeFlow } = useSetChangeRequest();
  const { modalFlow } = changeFlow;
  const { restartSubscription } = modalFlow;

  const handleCloseModalFlow = () => {
    if (restartSubscription.stepTwo && refetchSubscriptions) {
      refetchSubscriptions();
    }
    setChangeFlow(() => baseModalContext);
  };

  return (
    <Dialog
      open={restartSubscription.start}
      maxWidth="sm"
      fullWidth
      onClose={handleCloseModalFlow}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="flex-end">
          <IconButton
            icon={<CloseIcon />}
            label={formatMessage({ id: 'dashboard.subscriptions.restart.close' })}
            clickstreamProps={{ elementName: 'restart_modal_close' }}
            onClick={handleCloseModalFlow}
          />
        </Box>
      </DialogTitle>
      {restartSubscription.stepOne && (
        <ConfirmRestartSubscription
          subscription={subscription}
          businessEntityName={businessEntity?.name}
          serviceDisplayName={serviceDisplayName}
        />
      )}
      {restartSubscription.stepTwo && (
        <RequestSuccessful onClose={handleCloseModalFlow} />
      )}
      {modalFlow.error && (
        <ContactCS />
      )}
    </Dialog>
  );
}

RestartSubscriptionModalFlow.propTypes = {
  subscription: PropTypes.shape({
    orderBillingItemUuid: PropTypes.string,
    price: PropTypes.number,
    period: PropTypes.string,
    termEndDate: PropTypes.string
  }).isRequired,
  businessEntity: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  serviceDisplayName: PropTypes.string,
  refetchSubscriptions: PropTypes.func
};
